import { type BlokProps, StoryblokComponent } from "@trydig/storyblok";
import { clsx } from "@trydig/ui";
import { BlokWrap } from "~/components/bloks/BlokWrap";
import type { TagCloudStoryblok } from "~/generated/sb/blok-types";
import styles from "./TagCloudBlok.module.css";

export const TagCloudBlok = ({ blok, preview }: BlokProps<TagCloudStoryblok>) => {
	return (
		<BlokWrap data-layout="blok" data-container="small" className={styles.wrapper} editable={blok}>
			<div className={clsx(styles.root)}>
				{blok.tags.map((tag) => (
					<StoryblokComponent key={tag._uid} blok={tag} preview={preview} />
				))}
			</div>
			<div className={styles["image-placeholder"]} />
		</BlokWrap>
	);
};
